<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.6667 11.3333H10.3333V10.2423C10.3333 9.69967 10.1023 9.18033 9.699 8.81767L9.13467 8.31C9.04567 8.22967 8.99667 8.11967 8.99667 8C8.99667 7.88033 9.04567 7.77033 9.13467 7.69033L9.699 7.18267C10.1023 6.81933 10.3333 6.30033 10.3333 5.75767V4.66667H10.6667C10.851 4.66667 11 4.51733 11 4.33333C11 4.14933 10.851 4 10.6667 4H5.33333C5.149 4 5 4.14933 5 4.33333C5 4.51733 5.149 4.66667 5.33333 4.66667H5.66667V5.75767C5.66667 6.30033 5.89767 6.81967 6.301 7.18233L6.86533 7.69C6.95433 7.77033 7.00333 7.88033 7.00333 8C7.00333 8.11967 6.95433 8.22967 6.86533 8.30967L6.301 8.81733C5.89767 9.18067 5.66667 9.69967 5.66667 10.2423V11.3333H5.33333C5.149 11.3333 5 11.4827 5 11.6667C5 11.8507 5.149 12 5.33333 12H10.6667C10.851 12 11 11.8507 11 11.6667C11 11.4827 10.851 11.3333 10.6667 11.3333ZM6.66667 10.2763C6.66667 10.0313 6.762 9.80133 6.93533 9.628L7.82333 8.74C7.921 8.64233 8.07933 8.64233 8.177 8.74L9.065 9.628C9.23833 9.80133 9.33367 10.0313 9.33367 10.2763V11.3333H6.66667V10.2763Z"/>
  </svg>
</template>

<script>
export default {
name: "IconHourGlass"
}
</script>

<style scoped>

</style>